export default __webpack_public_path__ + "static/media/orisa-intro.33fe7bb0.mp3";